import { useState, useCallback } from "react";

export function useBulkOperations({ data, updateBulkStatus }) {
  const [bulkOperations, setBulkOperations] = useState({
    isActive: false,
    status: "",
    selectedCount: 0,
  });

  const handleBulkStatusUpdate = useCallback(
    (status) => {
      const selectedRows = data.filter((row) => row.isSelected);
      const publicIds = selectedRows.map((row) => row.publicId);
      const selectedCount = publicIds?.length;

      setBulkOperations({
        isActive: true,
        status,
        selectedCount: selectedRows.length,
      });

      return updateBulkStatus(status, publicIds, selectedCount);
    },
    [data, updateBulkStatus]
  );

  const resetBulkOperations = useCallback(() => {
    setBulkOperations({
      isActive: false,
      status: "",
      selectedCount: 0,
    });
  }, []);

  return {
    bulkOperations,
    handleBulkStatusUpdate,
    resetBulkOperations,
  };
}
